import { Box, makeStyles } from '@material-ui/core';

import { dividerColor, primaryDark } from 'src/data/colors';
import { EquipmentPortfolioType } from 'src/models';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: '#fff',
    border: `1px solid ${dividerColor}`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
  },
  leftSection: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
  imageContainer: {
    alignItems: 'center',
    display: 'flex',
    height: 48,
    justifyContent: 'center',
    width: 48,
  },
  image: {
    height: '100%',
    objectFit: 'contain',
    width: '100%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontSize: 16,
    fontWeight: 500,
    margin: 0,
  },
  type: {
    fontSize: 12,
    margin: 0,
  },
  quantity: {
    border: `1px solid ${primaryDark}`,
    borderRadius: 20,
    color: primaryDark,
    fontSize: 16,
    margin: 0,
    padding: '4px 16px',
  },
}));

const Equipment = ({ image, model, type, quantity }: EquipmentPortfolioType) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.leftSection}>
        <Box className={classes.imageContainer}>
          {image && <img src={image} alt={model} className={classes.image} />}
        </Box>
        <Box className={classes.textContainer}>
          <p className={classes.name}>{model}</p>
          <p className={classes.type}>{type}</p>
        </Box>
      </Box>
      <Box>
        <p className={classes.quantity}>{quantity}x</p>
      </Box>
    </Box>
  );
};

export default Equipment;
